"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentBuilder = void 0;
var abstract_builder_1 = require("./abstract-builder");
var segment_1 = require("../structs/segment");
var SegmentBuilder = (function (_super) {
    __extends(SegmentBuilder, _super);
    function SegmentBuilder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.Model = segment_1.Segment;
        return _this;
    }
    Object.defineProperty(SegmentBuilder.prototype, "channels", {
        get: function () {
            return this.data.channels;
        },
        enumerable: false,
        configurable: true
    });
    SegmentBuilder.prototype.setChannels = function (channels) {
        this.data.channels = channels;
        return this;
    };
    Object.defineProperty(SegmentBuilder.prototype, "computedStatus", {
        get: function () {
            return this.data.computedStatus;
        },
        enumerable: false,
        configurable: true
    });
    SegmentBuilder.prototype.setComputedStatus = function (computedStatus) {
        this.data.computedStatus = computedStatus;
        return this;
    };
    Object.defineProperty(SegmentBuilder.prototype, "createdAt", {
        get: function () {
            return this.data.createdAt;
        },
        enumerable: false,
        configurable: true
    });
    SegmentBuilder.prototype.setCreatedAt = function (createdAt) {
        this.data.createdAt = createdAt;
        return this;
    };
    Object.defineProperty(SegmentBuilder.prototype, "createdBy", {
        get: function () {
            return this.data.createdBy;
        },
        enumerable: false,
        configurable: true
    });
    SegmentBuilder.prototype.setCreatedBy = function (createdBy) {
        this.data.createdBy = createdBy;
        return this;
    };
    Object.defineProperty(SegmentBuilder.prototype, "createdByUserName", {
        get: function () {
            return this.data.createdByUserName;
        },
        enumerable: false,
        configurable: true
    });
    SegmentBuilder.prototype.setCreatedByUserName = function (createdByUserName) {
        this.data.createdByUserName = createdByUserName;
        return this;
    };
    Object.defineProperty(SegmentBuilder.prototype, "destroyedAt", {
        get: function () {
            return this.data.destroyedAt;
        },
        enumerable: false,
        configurable: true
    });
    SegmentBuilder.prototype.setDestroyedAt = function (destroyedAt) {
        this.data.destroyedAt = destroyedAt;
        return this;
    };
    Object.defineProperty(SegmentBuilder.prototype, "domainId", {
        get: function () {
            return this.data.domainId;
        },
        enumerable: false,
        configurable: true
    });
    SegmentBuilder.prototype.setDomainId = function (domainId) {
        this.data.domainId = domainId;
        return this;
    };
    Object.defineProperty(SegmentBuilder.prototype, "estimatedReach", {
        get: function () {
            return this.data.estimatedReach;
        },
        enumerable: false,
        configurable: true
    });
    SegmentBuilder.prototype.setEstimatedReach = function (estimatedReach) {
        this.data.estimatedReach = estimatedReach;
        return this;
    };
    Object.defineProperty(SegmentBuilder.prototype, "filtersJson", {
        get: function () {
            return this.data.filtersJson;
        },
        enumerable: false,
        configurable: true
    });
    SegmentBuilder.prototype.setFiltersJson = function (filtersJson) {
        this.data.filtersJson = filtersJson;
        return this;
    };
    Object.defineProperty(SegmentBuilder.prototype, "group", {
        get: function () {
            return this.data.group;
        },
        enumerable: false,
        configurable: true
    });
    SegmentBuilder.prototype.setGroup = function (group) {
        this.data.group = group;
        return this;
    };
    Object.defineProperty(SegmentBuilder.prototype, "iconUrl", {
        get: function () {
            return this.data.iconUrl;
        },
        enumerable: false,
        configurable: true
    });
    SegmentBuilder.prototype.setIconUrl = function (iconUrl) {
        this.data.iconUrl = iconUrl;
        return this;
    };
    Object.defineProperty(SegmentBuilder.prototype, "id", {
        get: function () {
            return this.data.id;
        },
        enumerable: false,
        configurable: true
    });
    SegmentBuilder.prototype.setId = function (id) {
        this.data.id = id;
        return this;
    };
    Object.defineProperty(SegmentBuilder.prototype, "isDefault", {
        get: function () {
            return this.data.isDefault;
        },
        enumerable: false,
        configurable: true
    });
    SegmentBuilder.prototype.setIsDefault = function (isDefault) {
        this.data.isDefault = isDefault;
        return this;
    };
    Object.defineProperty(SegmentBuilder.prototype, "lastTargetedDateUtc", {
        get: function () {
            return this.data.lastTargetedDateUtc;
        },
        enumerable: false,
        configurable: true
    });
    SegmentBuilder.prototype.setLastTargetedDateUtc = function (lastTargetedDateUtc) {
        this.data.lastTargetedDateUtc = lastTargetedDateUtc;
        return this;
    };
    Object.defineProperty(SegmentBuilder.prototype, "name", {
        get: function () {
            return this.data.name;
        },
        enumerable: false,
        configurable: true
    });
    SegmentBuilder.prototype.setName = function (name) {
        this.data.name = name;
        return this;
    };
    Object.defineProperty(SegmentBuilder.prototype, "source", {
        get: function () {
            return this.data.source;
        },
        enumerable: false,
        configurable: true
    });
    SegmentBuilder.prototype.setSource = function (source) {
        this.data.source = source;
        return this;
    };
    Object.defineProperty(SegmentBuilder.prototype, "topicName", {
        get: function () {
            return this.data.topicName;
        },
        enumerable: false,
        configurable: true
    });
    SegmentBuilder.prototype.setTopicName = function (topicName) {
        this.data.topicName = topicName;
        return this;
    };
    Object.defineProperty(SegmentBuilder.prototype, "treatmentSpec", {
        get: function () {
            return this.data.treatmentSpec;
        },
        enumerable: false,
        configurable: true
    });
    SegmentBuilder.prototype.setTreatmentSpec = function (treatmentSpec) {
        this.data.treatmentSpec = treatmentSpec;
        return this;
    };
    Object.defineProperty(SegmentBuilder.prototype, "flags", {
        get: function () {
            return this.data.flags;
        },
        enumerable: false,
        configurable: true
    });
    SegmentBuilder.prototype.setFlags = function (flags) {
        this.data.flags = Array.from(flags);
        return this;
    };
    Object.defineProperty(SegmentBuilder.prototype, "type", {
        get: function () {
            return this.data.type;
        },
        enumerable: false,
        configurable: true
    });
    SegmentBuilder.prototype.setType = function (type) {
        this.data.type = type;
        return this;
    };
    return SegmentBuilder;
}(abstract_builder_1.AbstractBuilder));
exports.SegmentBuilder = SegmentBuilder;
//# sourceMappingURL=segment-builder.js.map